import React from 'react';

import { IconType } from '@/components/IconSettings';
import { describeArc } from '@/components/ProgressIndicator/utils';

const size = 20;

function StatusProgressIcon(props: React.ComponentProps<IconType>) {
  const { color = 'black', progress: progressProp, height = size, width = size, className } = props;

  const progress = progressProp ?? 0;
  const endAngle = progress * 3.6;

  const d = describeArc(10, 10, 12, 0, endAngle);
  const id = `status-progress-icon-${progress}`;

  return (
    <svg className={className} fill="none" height={height} viewBox="0 0 20 20" width={width}>
      <mask id={id}>
        <rect fill="black" height="100%" width="100%"></rect>
        <path d={d} fill="white" />
      </mask>
      <rect
        fill="transparent"
        height="18"
        rx="4"
        ry="4"
        stroke={color}
        strokeWidth="1"
        width="18"
        x="1"
        y="1"
      />
      <rect fill={color} height="18" mask={`url(#${id})`} rx="4" ry="4" width="18" x="1" y="1" />
    </svg>
  );
}
export default StatusProgressIcon;
